import * as React from 'react';
import { SVGProps } from 'react';

const IconBagSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h2a1 1 0 0 1 1 1v1L8.303 7.9a1.25 1.25 0 0 1-.606 0L1 6V5a1 1 0 0 1 1-1h2V3zm2 1h4V3H6v1z"
    />
    <path d="M1 7.023V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.023L8.667 8.9a2.75 2.75 0 0 1-1.334 0L1 7.023z" />
  </svg>
);
export default IconBagSizeS;
